import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ConfirmationModalService } from '@epicuro-next/ataraxia/modal';
import {
  EngagementFeedWithUser,
  NewsfeedType,
} from '@epicuro-next/data/engagement/engagement-models';
import { actions } from '@epicuro-next/state/news-feed-state';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export abstract class NewsFeedBaseComponent implements OnDestroy {
  private title = $localize`:NewsFeed|Delete Article confirmation title@@deleteArticleConfirmationTitle:Delete from Newsfeed and Spotlight?`;

  public destroy$ = new Subject<void>();

  constructor(
    protected store: Store,
    protected confirmationService: ConfirmationModalService,
  ) {}

  public deleteArticle(article: EngagementFeedWithUser) {
    this.confirmationService
      .open({
        message: this.getDescription(article.title),
        title: this.title,
        isUseDeleteConfirmButton: true,
      })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(() => {
        if (!article.id || !article.referenceId || !article.type) {
          return;
        }

        this.store.dispatch(
          actions.deleteArticle({
            feedId: article.id,
            referenceId: article.referenceId,
            referenceType: article.type,
            newsfeedType: article.newsfeedType ?? NewsfeedType.Spotlight,
          }),
        );
      });
  }

  public navigateToArticle(article: EngagementFeedWithUser) {
    this.store.dispatch(
      actions.navigate({
        data: { type: article.type, referenceId: article.referenceId },
      }),
    );
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getDescription(name: string) {
    return $localize`:NewsFeed|Delete Single Article confirmation message@@deleteSingleArticleConfirmationMessage:Are you sure you want to delete "${name}" from the spotlight?`;
  }
}
